import BaseCommand from "@/models/api/commands/BaseCommand";

export class ReturnAdvanceInvoiceCommand extends BaseCommand {
  CommandName = "ReturnAdvanceInvoice";
  Command: string;
  constructor(sessionId: string, operationId: string, orderItemId: string) {
    super(sessionId, operationId);
    this.Command = orderItemId;
  }
}
